import { render, staticRenderFns } from "./applicant_import_dialog.vue?vue&type=template&id=3585a09e&scoped=true"
import script from "./applicant_import_dialog.vue?vue&type=script&lang=ts"
export * from "./applicant_import_dialog.vue?vue&type=script&lang=ts"
import style0 from "./applicant_import_dialog.vue?vue&type=style&index=0&id=3585a09e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585a09e",
  null
  
)

export default component.exports